import { render } from "./SupplierRequirementValues.vue?vue&type=template&id=aa50504c&scoped=true"
import script from "./SupplierRequirementValues.vue?vue&type=script&lang=js"
export * from "./SupplierRequirementValues.vue?vue&type=script&lang=js"

import "./SupplierRequirementValues.vue?vue&type=style&index=0&id=aa50504c&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa50504c"]])

export default __exports__